import '@angular/compiler';
import { PortalAnalysisWidgetStabilityComponent } from './portal.analysis.widget.stability/portal.analysis.widget.stability.component';
import { PortalOverviewWidgetAvgOutputsComponent } from './portal.overview.widget.avg.outputs/portal.overview.widget.avg.outputs.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { LayoutDefaultComponent } from './layout.default/layout.default.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentUndefindComponent } from './component.undefind/component.undefind.component';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { ComponentTooltipComponent } from './component.tooltip/component.tooltip.component';
import { PortalNetworkWidgetDetailComponent } from './portal.network.widget.detail/portal.network.widget.detail.component';
import { PortalOverviewDashboardComponent } from './portal.overview.dashboard/portal.overview.dashboard.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalAchievementsListComponent } from './portal.achievements.list/portal.achievements.list.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalAnalysisWidgetScalabilityComponent } from './portal.analysis.widget.scalability/portal.analysis.widget.scalability.component';
import { PortalOverviewWidgetComponent } from './portal.overview.widget/portal.overview.widget.component';
import { PortalAnalysisWidgetCategoryComponent } from './portal.analysis.widget.category/portal.analysis.widget.category.component';
import { PageDetailComponent } from './page.detail/page.detail.component';
import { PortalOverviewWidgetWordcloudComponent } from './portal.overview.widget.wordcloud/portal.overview.widget.wordcloud.component';
import { PortalAnalysisWidgetSearchComponent } from './portal.analysis.widget.search/portal.analysis.widget.search.component';
import { PortalOverviewWidgetTop5Component } from './portal.overview.widget.top5/portal.overview.widget.top5.component';
import { PortalOverviewWidgetChartComponent } from './portal.overview.widget.chart/portal.overview.widget.chart.component';
import { PortalNetworkWidgetGraphComponent } from './portal.network.widget.graph/portal.network.widget.graph.component';
import { PortalAnalysisWidgetExpertiseComponent } from './portal.analysis.widget.expertise/portal.analysis.widget.expertise.component';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalOverviewWidgetOutputsComponent } from './portal.overview.widget.outputs/portal.overview.widget.outputs.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalNetworkDashboardComponent } from './portal.network.dashboard/portal.network.dashboard.component';
import { ComponentSearchComponent } from './component.search/component.search.component';
import { PageListComponent } from './page.list/page.list.component';
import { PortalOverviewWidgetStabilityComponent } from './portal.overview.widget.stability/portal.overview.widget.stability.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalAnalysisDashboardComponent } from './portal.analysis.dashboard/portal.analysis.dashboard.component';

const INDEX_PAGE = "main";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutDefaultComponent,
        "children": [
            {
                "path": "detail/:id?/:category?",
                component: PageDetailComponent,
                "app_id": "page.detail"
            },
            {
                "path": "list",
                component: PageListComponent,
                "app_id": "page.list"
            }
        ]
    },
    {
        component: LayoutMainComponent,
        "children": [
            {
                "path": "main",
                component: PageMainComponent,
                "app_id": "page.main"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }